import { compose } from "redux";

import AutoSuggestInput from ".";
import Default from "./Default";
import Error from "../Error";
import extractAutoSuggestQueryParams from "./ExtractQueryParams";
import generateSuggestionList from "./GenerateSuggestionList";
import withContainer from "../common/hoc/WithContainer";

import { search } from "../../services/MODSService";

export default compose(
    extractAutoSuggestQueryParams(),
    withContainer({
        dataParams: {
            fetchHandler: search
        },
        defaultLoadingMessage: "Loading auto suggestions",
        Error,
        DefaultComponent: Default
    }),
    generateSuggestionList()
// eslint-disable-next-line @typescript-eslint/no-explicit-any
)(AutoSuggestInput) as React.FunctionComponent<any>;
